import { render, staticRenderFns } from "./SerialFooter.vue?vue&type=template&id=6954c351&scoped=true&"
import script from "./SerialFooter.vue?vue&type=script&lang=js&"
export * from "./SerialFooter.vue?vue&type=script&lang=js&"
import style0 from "./SerialFooter.vue?vue&type=style&index=0&id=6954c351&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6954c351",
  null
  
)

export default component.exports